// extracted by mini-css-extract-plugin
module.exports = {"caption":"_113d42","root":"_78b528","image":"_8ddda4","narrowImage":"_2be034"};